import { useRef, useState } from "react";

export default function useMediaPlayer() {
  const audioRef = useRef(null);
  const [playingId, setPlayingId] = useState(null);

  function play(song) {
    if (!song) return;

    const preview = song?.FilesAttrs?.audio?.[0]?.url;
    if (!preview) return;

    const audio = audioRef.current;
    if (!audio) return;

    // toggle
    if (playingId === song.id) {
      audio.pause();
      setPlayingId(null);
      return;
    }

    audio.src = preview;
    audio.currentTime = 20;
    audio.play();

    setPlayingId(song.id);

    setTimeout(() => {
      audio.pause();
      setPlayingId(null);
    }, 30000);
  }

  return {
    audioRef,
    playingId,
    play
  };
}